import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ContentProvider } from "./contexts/ContentContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import { ServicesOverview, ServiceDetail } from "./pages/ServicesPage";
import SectorsPage from "./pages/SectorsPage";
import TeamPage from "./pages/TeamPage";
import InsightsPage, { BlogDetail } from "./pages/InsightsPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import ContactPage from "./pages/ContactPage";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout, { AdminDashboard } from "./pages/AdminDashboard";
import AdminLeads from "./pages/AdminLeads";
import AdminBlogs from "./pages/AdminBlogs";
import AdminCaseStudies from "./pages/AdminCaseStudies";
import AdminTeam from "./pages/AdminTeam";
import AdminContent from "./pages/AdminContent";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-2 border-gold-500 border-t-transparent rounded-full animate-spin" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><ServicesOverview /></PublicLayout>} />
            <Route path="/services/:slug" element={<PublicLayout><ServiceDetail /></PublicLayout>} />
            <Route path="/sectors" element={<PublicLayout><SectorsPage /></PublicLayout>} />
            <Route path="/team" element={<PublicLayout><TeamPage /></PublicLayout>} />
            <Route path="/insights" element={<PublicLayout><InsightsPage /></PublicLayout>} />
            <Route path="/insights/:slug" element={<PublicLayout><BlogDetail /></PublicLayout>} />
            <Route path="/case-studies" element={<PublicLayout><CaseStudiesPage /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="content" element={<AdminContent />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="blogs" element={<AdminBlogs />} />
              <Route path="case-studies" element={<AdminCaseStudies />} />
              <Route path="team" element={<AdminTeam />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </AuthProvider>
  );
}

export default App;
